module.exports = __webpack_public_path__ + "img/icon.e5c6c8d8.svg";